import ApiResponseError from "../types/ApiResponseError";
import getApiUrl from "./getApiUrl";

export default async function request<T>(method: string, path: string, body?: any): Promise<T> {
    const response = await fetch(getApiUrl(path), {
        method,
        body: typeof body === "object" ? JSON.stringify(body) : body,
        headers: {
            "accept": "application/json",
            "content-type": "application/json"
        },
        credentials: "include"
    });

    if (!response.ok) {
        throw new ApiResponseError(response);
    }

    return await response.json();
};
